<template>
    <div class="full-width q-py-xs">
        <q-card class="full-width full-height no-shadow border-grey">
            <q-form @submit="submit">
                <q-card-section>
                    <div class="row justify-between">
                        <!-- Fields column (breaks down to 2 columns on medium devices, single column on small devices) -->
                        <div class="col-9">
                            <div class="row">
                                <!-- First column of fields -->
                                <div class="col-xs-12 col-md-6 full-height">
                                    <q-chip
                                        v-if="!inlineEditMode"
                                        color="darker-yellow"
                                        :label="$t('Quality')"
                                        class="q-mx-none q-mb-sm text-uppercase"
                                        text-color="white"
                                        style="font-weight: 500"
                                        square
                                    />
                                    <!-- Date range field -->
                                    <div v-if="!inlineEditMode" class="row">
                                        <q-icon
                                            name="far fa-calendar-alt"
                                            class="q-mr-xs"
                                            size="sm"
                                            color="grey"
                                            :style="{
                                                'margin-top:6px;':
                                                    $q.screen.lt.sm
                                            }"
                                        >
                                            <q-tooltip
                                                anchor="bottom middle"
                                                self="top middle"
                                            >
                                                {{ $t('Date range') }}
                                            </q-tooltip>
                                        </q-icon>
                                        <div
                                            v-if="end === null"
                                            class="q-ml-xs"
                                        >
                                            <span
                                                :class="{
                                                    'span-display-block':
                                                        $q.screen.lt.sm
                                                }"
                                            >
                                                {{
                                                    formatDate(
                                                        start,
                                                        userLocale
                                                    )
                                                }}</span
                                            >
                                            <span
                                                :class="{
                                                    'span-display-block':
                                                        $q.screen.lt.sm
                                                }"
                                            >
                                                {{ ` (${$t('Ongoing')})` }}
                                            </span>
                                        </div>
                                        <div
                                            v-else
                                            class="q-ml-xs"
                                            style="margin-top: 2px"
                                        >
                                            <span
                                                :class="{
                                                    'span-display-block':
                                                        $q.screen.lt.sm
                                                }"
                                            >
                                                {{
                                                    formatDate(
                                                        start,
                                                        userLocale
                                                    )
                                                }}
                                            </span>
                                            <span
                                                :class="{
                                                    'span-display-none':
                                                        $q.screen.lt.sm
                                                }"
                                            >
                                                -
                                            </span>
                                            <span
                                                :class="{
                                                    'span-display-block':
                                                        $q.screen.lt.sm
                                                }"
                                            >
                                                {{
                                                    formatDate(end, userLocale)
                                                }}
                                            </span>
                                        </div>
                                    </div>
                                    <div
                                        v-else
                                        class="col-xs-12 col-md-6 full-height q-mr-sm"
                                        :class="{
                                            'span-display-block':
                                                $q.screen.lt.sm
                                        }"
                                    >
                                        <date-time-picker
                                            v-model="form.start"
                                            :label="$t('Start')"
                                            :disable="true"
                                        />
                                        <date-time-picker
                                            v-model="form.end"
                                            :label="$t('End')"
                                            :disable="true"
                                            :style="
                                                $q.screen.lt.md
                                                    ? 'margin-top: 16px;'
                                                    : 'margin-top: -4px;'
                                            "
                                        />
                                    </div>
                                    <div v-if="!inlineEditMode" class="q-my-xs">
                                        <q-icon
                                            name="fa-light fa-xmark-to-slot"
                                            class="q-mr-xs"
                                            color="grey"
                                            size="sm"
                                        />
                                        {{
                                            $t(
                                                'Rejected products: {rejectedProductCount}',
                                                {
                                                    rejectedProductCount:
                                                        formatProductionValue(
                                                            rejectedProductCount
                                                        )
                                                }
                                            )
                                        }}
                                    </div>
                                    <div v-else>
                                        <q-input
                                            :label="$t('Rejected Products')"
                                            v-model="form.rejectedProductCount"
                                            class="q-mr-sm"
                                            :class="{
                                                'q-mt-md': $q.screen.lt.md
                                            }"
                                            outlined
                                            :disable="true"
                                        />
                                    </div>

                                    <div v-if="!inlineEditMode" class="q-my-xs">
                                        <q-icon
                                            name="fa-light fa-box-circle-check"
                                            class="q-mr-xs"
                                            size="sm"
                                            color="grey"
                                            :style="{
                                                'margin-top:6px;':
                                                    $q.screen.lt.sm
                                            }"
                                        />
                                        {{
                                            $t(
                                                'Total Products: {grossProductCount}',
                                                {
                                                    grossProductCount
                                                }
                                            )
                                        }}
                                    </div>
                                    <div v-else>
                                        <q-input
                                            :label="$t('Total Products')"
                                            v-model="form.grossProductCount"
                                            class="q-mr-sm q-mt-md"
                                            outlined
                                            :disable="true"
                                        />
                                    </div>
                                </div>

                                <!-- Second column of fields -->
                                <div class="col-xs-12 col-md-6 full-height">
                                    <div v-if="!inlineEditMode" class="q-my-xs">
                                        <q-icon
                                            name="far fa-conveyor-belt"
                                            class="q-mr-xs"
                                            color="grey"
                                            size="sm"
                                        >
                                            <q-tooltip
                                                anchor="bottom middle"
                                                self="top middle"
                                            >
                                                {{ $t('Asset') }}
                                            </q-tooltip>
                                        </q-icon>
                                        {{ assetName }}
                                    </div>
                                    <!-- Second column of fields Edit Mode -->
                                    <div
                                        v-else
                                        class="col-xs-12 col-md-6 full-height"
                                    >
                                        <div class="q-mr-sm">
                                            <!-- asset dropdown -->
                                            <q-select
                                                v-model="form.asset"
                                                :options="assetOptions"
                                                :label="$t('Asset')"
                                                :rules="[
                                                    val =>
                                                        (val !== '' &&
                                                            val !== null) ||
                                                        $t('Select an asset')
                                                ]"
                                                :class="{
                                                    'q-my-md full-width':
                                                        $q.screen.lt.md
                                                }"
                                                behavior="dialog"
                                                disable
                                                clearable
                                                outlined
                                                emit-value
                                                map-options
                                                color="accent"
                                            />
                                        </div>
                                    </div>
                                    <div
                                        v-if="!inlineEditMode"
                                        class="q-mr-sm q-my-xs"
                                    >
                                        <q-icon
                                            name="far fa-box"
                                            class="q-mr-xs"
                                            color="grey"
                                            size="sm"
                                        >
                                            <q-tooltip
                                                anchor="bottom middle"
                                                self="top middle"
                                            >
                                                {{ $t('Product') }}
                                            </q-tooltip>
                                        </q-icon>
                                        {{ productName }}
                                    </div>
                                    <div
                                        v-else
                                        :class="
                                            $q.screen.lt.md
                                                ? 'q-my-md'
                                                : 'q-my-md q-mb-md'
                                        "
                                        class="q-mr-sm"
                                    >
                                        <table-select
                                            v-model="form.product"
                                            @confirmSelection="
                                                form.product =
                                                    productSelectProps.selection
                                            "
                                            :baseURL="productSelectProps.url"
                                            :queryParams="
                                                productSelectProps.queryParams
                                            "
                                            :label="productSelectProps.label"
                                            :dialogTitle="
                                                productSelectProps.dialogTitle
                                            "
                                            :searchLabel="
                                                productSelectProps.searchLabel
                                            "
                                            row-key="id"
                                            :disable="true"
                                        >
                                            <template v-slot:item="data">
                                                <product-card
                                                    @select="
                                                        productSelectProps.selection =
                                                            {
                                                                label: data
                                                                    .props.row
                                                                    .name,
                                                                value: data
                                                                    .props.row
                                                                    .product
                                                            }
                                                    "
                                                    :name="data.props.row.name"
                                                    :code="data.props.row.code"
                                                    :description="
                                                        data.props.row
                                                            .description
                                                    "
                                                    :unit-measure="
                                                        data.props.row
                                                            .unit_measure
                                                    "
                                                    :unit-packing="
                                                        data.props.row
                                                            .unit_packing
                                                    "
                                                    :isSelected="
                                                        productSelectProps.selection &&
                                                        productSelectProps
                                                            .selection.value ===
                                                            data.props.row
                                                                .product
                                                    "
                                                    :isSelectable="true"
                                                />
                                            </template>
                                        </table-select>
                                    </div>
                                    <div
                                        v-if="!inlineEditMode"
                                        class="q-mr-sm q-mb-md"
                                    >
                                        <div v-if="defectName">
                                            <q-icon
                                                name="far fa-exclamation-circle"
                                                class="q-mr-xs"
                                                size="sm"
                                                color="grey"
                                            >
                                                <q-tooltip
                                                    anchor="bottom middle"
                                                    self="top middle"
                                                >
                                                    {{ $t('Defect') }}
                                                </q-tooltip>
                                            </q-icon>
                                            {{ defectName }}
                                        </div>
                                        <missing-defect-label
                                            v-else
                                            v-model="
                                                missingDefectProps.selection
                                            "
                                            :eventId="eventId"
                                            :assetId="assetId"
                                            @refreshList="refreshList()"
                                            @clearSelection="
                                                missingDefectProps.selection =
                                                    null
                                            "
                                            :baseURL="`assets/${assetId}/defects/`"
                                            :queryParams="
                                                missingDefectProps.queryParams
                                            "
                                            :label="missingDefectProps.label"
                                            :dialogTitle="
                                                missingDefectProps.dialogTitle
                                            "
                                            :searchLabel="
                                                missingDefectProps.searchLabel
                                            "
                                        >
                                            <template v-slot:item="data">
                                                <defect-card
                                                    @select="
                                                        select(
                                                            data.props.row,
                                                            missingDefectProps
                                                        )
                                                    "
                                                    :name="data.props.row.name"
                                                    :code="data.props.row.code"
                                                    :description="
                                                        data.props.row
                                                            .description
                                                    "
                                                    :isSelected="
                                                        missingDefectProps.selection &&
                                                        missingDefectProps
                                                            .selection.value ===
                                                            data.props.row.id
                                                    "
                                                    :isSelectable="true"
                                                />
                                            </template>
                                        </missing-defect-label>
                                    </div>
                                    <div v-else class="q-mr-sm">
                                        <defect-table-select
                                            v-if="defectSelectProps.url"
                                            v-model="form.defect"
                                            @confirmSelection="
                                                form.defect = {
                                                    label: defectSelectProps
                                                        .selection.name,
                                                    value: defectSelectProps
                                                        .selection.id
                                                }
                                            "
                                            :baseURL="defectSelectProps.url"
                                            :queryParams="
                                                defectSelectProps.queryParams
                                            "
                                            :label="defectSelectProps.label"
                                            :dialogTitle="
                                                defectSelectProps.dialogTitle
                                            "
                                            :searchLabel="
                                                defectSelectProps.searchLabel
                                            "
                                            :facilityId="
                                                defectSelectProps.facilityId
                                            "
                                            :rules="[
                                                val =>
                                                    !!val ||
                                                    $t('Select a Defect')
                                            ]"
                                            row-key="id"
                                            class="q-pt-xs"
                                        >
                                            <template v-slot:item="data">
                                                <defect-card
                                                    @select="
                                                        defectSelectProps.selection =
                                                            data.props.row
                                                    "
                                                    :name="data.props.row.name"
                                                    :code="data.props.row.code"
                                                    :description="
                                                        data.props.row
                                                            .description
                                                    "
                                                    :isSelected="
                                                        defectSelectProps.selection &&
                                                        defectSelectProps
                                                            .selection.id ===
                                                            data.props.row.id
                                                    "
                                                    :isSelectable="true"
                                                />
                                            </template>
                                        </defect-table-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Action column -->
                        <div
                            v-if="!inlineEditMode"
                            class="col-2 col-sm-3"
                            align="right"
                        >
                            <!-- Edit Button -->
                            <q-btn
                                @click="
                                    () => {
                                        inlineEditMode = true;
                                    }
                                "
                                :disable="$userCannot('edit', 'quality_events')"
                                :size="gridButtonSize"
                                class="q-mr-sm q-my-sm bg-white"
                                color="accent"
                                icon="fas fa-edit"
                                outline
                            />
                            <q-btn
                                @click="
                                    $router.push({
                                        name: 'asset_timeline',
                                        params: {
                                            assetId: assetId
                                        },
                                        query: {
                                            datetime: start
                                        }
                                    })
                                "
                                class="q-mr-sm q-my-sm bg-white"
                                :size="gridButtonSize"
                                icon="fas fa-history"
                                color="accent"
                                no-caps
                                outline
                            >
                                <q-tooltip>
                                    {{
                                        $t(
                                            'Go to the phase timeline of this asset'
                                        )
                                    }}
                                </q-tooltip>
                            </q-btn>
                        </div>
                        <q-card-actions
                            v-else
                            class="col-3"
                            align="right"
                            vertical
                        >
                            <q-btn
                                type="submit"
                                class="q-pa-sm q-mb-sm"
                                :loading="loading"
                                :disable="!formHasChanged"
                                icon="fas fa-check"
                                color="positive"
                                text-color="white"
                                :size="gridButtonSize"
                            >
                                <q-tooltip>
                                    {{ $t('Save') }}
                                </q-tooltip>
                            </q-btn>
                            <q-btn
                                @click="cancelEditing"
                                class="q-pa-sm"
                                icon="fas fa-times"
                                color="negative"
                                :size="gridButtonSize"
                                outline
                            >
                                <q-tooltip>
                                    {{ $t('Cancel') }}
                                </q-tooltip>
                            </q-btn>
                        </q-card-actions>
                    </div>
                </q-card-section>
            </q-form>
        </q-card>
    </div>
</template>
<script>
import DateTimePicker from '@components/DateTimePicker.vue';
import DefectCard from '@components/DefectCard.vue';
import DefectTableSelect from '@components/DefectTableSelect.vue';
import MissingDefectLabel from '@components/MissingDefectLabel.vue';
import ProductCard from '@components/ProductCard.vue';
import TableSelect from '@components/TableSelect.vue';
import { getLocaleFormat } from '@models/timeformats.js';
import { editPhaseInfoMessage } from '@utils/getMessages.js';
import { formatProductionValue } from '@utils/numberFormatters.js';
import { mapActions, mapState } from 'pinia';
import { useSharedStore } from '@stores/shared.js';
import { useAuthStore } from '@stores/auth';

export default {
    name: 'QualityEventCard',
    components: {
        DateTimePicker,
        DefectTableSelect,
        DefectCard,
        ProductCard,
        TableSelect,
        MissingDefectLabel
    },
    emits: ['split', 'save', 'refreshList'],
    props: {
        /**
         * General Object fields
         */
        facilityId: {
            type: String,
            required: false
        },
        eventId: {
            type: Number,
            required: true
        },
        defectId: {
            type: Number,
            required: false
        },
        defectName: {
            type: String,
            required: false
        },
        assetId: {
            type: Number,
            required: false
        },
        assetName: {
            type: String,
            required: false
        },
        productName: {
            type: String,
            required: false
        },
        rejectedProductCount: {
            type: Number,
            required: false
        },
        grossProductCount: {
            type: Number,
            required: false
        },
        /**
         * Event fields
         */
        start: {
            type: String,
            required: false
        },
        end: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            // time formats
            loading: false,
            timezone: 'local',
            inlineEditMode: false,
            assetOptions: [],
            form: {
                asset: '',
                start: null,
                end: null,
                defect: null,
                rejectedProductCount: null,
                grossProductCount: null,
                product: null
            },
            // selectors
            defectSelectProps: {
                url: `/assets/${this.assetId}/defects/`,
                queryParams: { order: 'name' },
                label: this.$t('Select a Defect'),
                dialogTitle: this.$t('Select a Defect'),
                searchLabel: this.$t('Search a defect'),
                selection: null
            },
            productSelectProps: {
                url: `/assets/${this.assetId}/products/`,
                queryParams: { ordering: 'name' },
                label: this.$t('Product'),
                dialogTitle: this.$t('Select a product'),
                searchLabel: this.$t('Search product'),
                selection: null
            },
            // selector for missing defect label
            missingDefectProps: {
                queryParams: { ordering: 'name' },
                label: this.$t('Defect'),
                dialogTitle: this.$t('Select a Defect'),
                searchLabel: this.$t('Search a defect'),
                selection: null
            },
            editPhaseInfoMessage
        };
    },
    computed: {
        ...mapState(useAuthStore, {
            userLocale: 'getUserLocale'
        }),
        /*
         * Get Grid Button Size depending on the the screen size
         * @return {String} button size
         */
        gridButtonSize() {
            return this.$q.screen.lt.xs
                ? 'sm'
                : this.$q.screen.lt.md
                  ? 'md'
                  : 'lg';
        },
        /**
         * Payload to send server to update event.
         * @return {Object}
         */
        payload() {
            const payload = {
                start: this.form.start,
                end:
                    this.form['end'] === '' || this.form['end'] === null
                        ? null
                        : this.form['end'],
                asset: parseInt(this.assetId),
                defect: parseInt(this.form.defect.value)
            };

            return payload;
        },
        /**
         * Enable the submit button when the user updates the form.
         * @return {Boolean}
         */
        formHasChanged() {
            if (!this.form.defect || !this.form.defect.value) {
                return false;
            }
            return this.defectId != this.form.defect.value;
        }
    },
    async created() {
        // begin loading
        this.beginLoading(`${this.$t('Loading event')}...`);
        this.initForm();
        // init the options for asset dropdown
        this.initAssetOptions();

        // stop loading
        this.stopLoading();
    },
    methods: {
        ...mapActions(useSharedStore, ['beginLoading', 'stopLoading']),
        formatProductionValue,
        /**
         * Format a date to local date format
         * @param {String} datetime
         * @param {String} locale
         * @return {String} datetime in given locale.
         */
        formatDate(datetime, locale) {
            return getLocaleFormat(datetime, locale);
        },
        /**
         * Initialize form.
         */
        initForm() {
            this.form.asset = this.assetId;
            this.form.start = this.start;
            this.form.end = this.end;
            this.form.rejectedProductCount = this.rejectedProductCount;
            this.form.grossProductCount = this.grossProductCount;
            this.form.product = {
                label: this.productName,
                value: this.product
            };

            if (this.defectId && this.defectName) {
                this.form.defect = {
                    label: this.defectName,
                    value: this.defectId
                };
            }
        },
        /**
         * Save Event.
         */
        async submit() {
            this.loading = true;
            const errorMessage = this.$t(
                'Failed to update event. Please try again later.'
            );
            await this.$axios
                .put(`quality_events/${this.eventId}/`, this.payload)
                .then(response => {
                    this.$notifySuccess(this.$t('Event updated'));
                    this.$emit('save');
                })
                .catch(error => {
                    this.$notifyError(errorMessage, error);
                })
                .finally(() => {
                    this.loading = false;
                    this.inlineEditMode = false;
                });
        },

        /**
         * Init the options of the asset dropdown
         */
        initAssetOptions() {
            // get the assets from store
            const assets = this.$store.getters['facilities/getAssets'](
                this.facilityId
            );
            // init the asset options
            assets.forEach(asset => {
                this.assetOptions.push({
                    label: asset['name'],
                    value: asset['id']
                });
            });
        },
        /**
         * Select/ deselect defect and products in table-select component
         * @param {Object} row - Event from table row.
         * @param {Object} props - Table selection props (productTableSelect, MissingDefectLabel)
         */
        select(row, props) {
            if (props.selection && props.selection.value === row.id) {
                props.selection = null;
            } else {
                props.selection = {
                    label: row.name,
                    value: row.id
                };
            }
        },
        /**
         * Triggers the refresh list method from the parent component after adding a defect
         */
        refreshList() {
            this.$emit('refreshList');
        },
        /**
         * Convert a given date to ISO String and reset the milliseconds
         * @param {String} date - Date
         * @return {String} date in ISO format
         */
        dateToIsoString(date) {
            const newDate = new Date(date);
            newDate.setMilliseconds(0);
            return newDate.toISOString();
        },
        /**
         * Cancel editing and reset the state of product, and defect fields.
         */
        cancelEditing() {
            this.defectSelectProps.selection = null;
            this.productSelectProps.selection = null;
            this.inlineEditMode = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.missing-cause {
    color: $negative;
    font-weight: 500;
}

.span-display-block {
    display: block;
}
.span-display-none {
    display: none;
}
</style>
